import { useEffect, useState } from "react";
import { Image as ImageIcon } from "@phosphor-icons/react";
import axiosInstance from "../../../api/axiosInstance";
import ImageLoader from "../../loader/ImageLoader";

// Resolves an S3 photo key (promo.photo_url) into a presigned URL and renders it.
// Shows a Lottie loader while resolving and a graceful placeholder on failure /
// when no image is attached.
export default function PromoImage({ photoKey, alt = "Promotion", className = "" }) {
    const [url, setUrl] = useState("");
    const [loading, setLoading] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let active = true;

        const resolve = async () => {
            if (!photoKey) {
                setUrl("");
                setFailed(false);
                return;
            }
            // Already an absolute URL — use as-is.
            if (/^https?:\/\//i.test(photoKey)) {
                setUrl(photoKey);
                return;
            }
            try {
                setLoading(true);
                setFailed(false);
                const response = await axiosInstance.get(
                    `/api/v1/images/download-presigned-url?key=${encodeURIComponent(photoKey)}`
                );
                if (active) setUrl(response?.data?.url || "");
            } catch (error) {
                if (active) {
                    setFailed(true);
                    setUrl("");
                }
            } finally {
                if (active) setLoading(false);
            }
        };

        resolve();
        return () => {
            active = false;
        };
    }, [photoKey]);

    return (
        <div className={`relative w-full shrink-0 overflow-hidden bg-[#F4F6FB] flex items-center justify-center ${className}`}>
            {loading && <ImageLoader width={60} height={60} />}

            {!loading && url && (
                <img
                    src={url}
                    alt={alt}
                    className="w-full h-full object-cover"
                    onError={() => {
                        setFailed(true);
                        setUrl("");
                    }}
                />
            )}

            {!loading && !url && (
                <div className="flex flex-col items-center gap-1 text-gray-300 py-6">
                    <ImageIcon size={34} weight="thin" />
                    <span className="text-[11px] text-gray-400">{failed ? "Image unavailable" : "No image"}</span>
                </div>
            )}
        </div>
    );
}
